// @flow
import styled from 'styled-components';
import SVGIcon from '~/core/icons/svg-icons';

export const ListItem = styled.li`
    align-items: center;
    display: flex;
    height: 3em;
`;

export const ItemIcon = styled(SVGIcon)`
    height: 2.6em;
    margin-right: 1em;
    flex: 0 0 2.6em;
`;

export const ItemTexts = styled.div`flex: 1 0 5em;`;

export const ItemRequired = styled.div`
    color: ${p => (p.noError ? 'inherit' : p.theme.error)};
    font-size: 0.8em;
    padding-top: 0.1em;
`;

export const ItemExclamation = styled(SVGIcon)`
    height: 2.6em;
    margin-left: 1em;
    flex: 0 0 1.8em;

    & > g {
        fill: ${p => p.theme.error};
    }
`;



// WEBPACK FOOTER //
// ./src/components/widgets/actions/template-description/description-item/styles.js